import {AceCascadingSelectComponent} from './ace-cascading-select/ace-cascading-select.component';
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {DateTimeRangeSelectComponent} from './date-time-range-select/date-time-range-select.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {SharedPipesModule} from '../';
import {DemandSelectComponent} from './demand-select/demand-select.component';
import {EquipmentSelectComponent} from './equipment-single-select/equipment-select.component';
import {SiteSelectComponent} from './site-select/site-select.component';
import {EquipmentGroupComponent} from '@app/layout/charts/chart-controls/equipment-group/equipment-group.component';
import {SharedDirectivesModule} from '@app/shared';
import {ErrorComponent} from './error/error.component';
import {ConfirmationComponent} from './confirmation/confirmation.component';
import {CheckboxListComponent} from './checkbox-list/checkbox-list.component';
import {StartEndTimeComponent} from './start-end-time/start-end-time.component';
import {NgxDatatableModule} from '@swimlane/ngx-datatable';
import {ErrorsComponent} from './errors/errors.component';
import {MetadataTypesSelectComponent} from './metadata-types-select/metadata-types-select.component';
import {MetadataUnitSelectComponent} from './metadata-unit-select/metadata-unit-select.component';
import {MetadataSelectComponent} from './metadata-select/metadata-select.component';
import {AceSelectComponent} from './ace-select/ace-select.component';
import {NgSelectModule} from '@ng-select/ng-select';
import {AceImageCropperComponent} from './ace-image-cropper/ace-image-cropper.component';
import {ImageCropperComponent} from 'ngx-image-cropper';
import {FavouritesSelectComponent} from './favourites-select/favourites-select.component';
import {ClientsSelectComponent} from './clients-select/clients-select.component';
import {TasksSelectComponent} from './tasks-select/tasks-select.component';
import {AceTableComponent} from './ace-table/ace-table.component';
import {CopyEquipmentGroupComponent} from '@app/layout/charts/chart-controls/equipment-group/copy-equipment-group/copy-equipment-group.component';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {LevelSelectComponent} from './level-select/level-select.component';
import {ZoneSelectComponent} from './zone-select/zone-select.component';
import {ContractorSelectComponent} from './contractor-select/contractor-select.component';
import {SelectFunctionModalComponent} from '@app/layout/charts/chart-controls/equipment-group/select-function-modal/select-function-modal.component';
import {ToasterComponent} from './toaster/toaster.component';
import {UiSwitchModule} from 'ngx-ui-switch';
import {NetworkProviderPlanSelectComponent} from './network-providers/network-provider-plan-select/network-provider-plan-select.component';
import {AddEditNetworkProviderPlanChargeComponent} from './network-providers/add-edit-network-provider-plan-charge/add-edit-network-provider-plan-charge.component';
import {NetworkProviderTypeSelectComponent} from './network-providers/network-provider-type-select/network-provider-type-select.component';
import {NetworkProviderSelectComponent} from './network-providers/network-provider-select/network-provider-select.component';
import {TimezoneSelectComponent} from './timezone-select/timezone-select.component';
import {AceChipsComponent} from './ace-chips/ace-chips.component';
import {LevelsSelectComponent} from './levels-select/levels-select.component';
import {ZonenamesSelectComponent} from './zonenames-select/zonenames-select.component';
import {TimePickerComponent} from './time-picker/time-picker.component';
import {TimePickerDayComponent} from './time-picker/time-picker-day/time-picker-day.component';
import {LevelZoneTreeComponent} from './level-zone-tree/level-zone-tree.component';
import {TreeModule} from '@ali-hm/angular-tree-component';
import {CountrySelectComponent} from './country-select/country-select.component';
import {DateTimeSelectComponent} from './date-time-select/date-time-select.component';
import {EllipsisComponent} from './ellipsis/ellipsis.component';
import {HeaderComponent} from './header/header.component';
import {RouterModule} from '@angular/router';
import {SingleLetterIconComponent} from './single-letter-icon/single-letter-icon.component';
import {LevelZoneSelectComponent} from './level-zone-select/level-zone-select.component';
import {EllipsesNCharsComponent} from './ellipses-n-chars/ellipses-n-chars.component';
import {AceTablePagerComponent} from './ace-table/ace-table-pager/ace-table-pager.component';
import {CanvasChartComponent} from '@shared/components/canvas-chart/canvas-chart.component';
import {ResizableContainerComponent} from '@shared/components/resizable-container/resizable-container.component';
import {ResizableModule} from 'angular-resizable-element';
import {AceFileUploadComponent} from './ace-file-upload/ace-file-upload.component';
import {ngfModule} from 'angular-file';
import {AceLoadingComponent} from '@shared/components/ace-loading/ace-loading.component';
import {EscalatedTicketCreateButtonComponent} from '@shared/components/escalated-ticket-create-button/escalated-ticket-create-button.component';
import {AceCurrencyComponent} from '@shared/components/ace-currency/ace-currency.component';
import {TemplateSelectComponent} from './template-select/template-select.component';
import {RecalculateMeterdataButtonComponent} from '@shared/components/recalculate-meterdata-button/recalculate-meterdata-button.component';
import {AcePaginationComponent} from './ace-pagination/ace-pagination.component';
import {AceProgressBarComponent} from './ace-progress-bar/ace-progress-bar.component';
import {SiteSelectWithSingleAndMultiComponent} from './site-select-with-single-and-multi/site-select-with-single-and-multi.component';
import {PageSiteAndDateRangeSelectComponent} from './page-site-and-date-range-select/page-site-and-date-range-select.component';
import {AceTableDefaultHeaderComponent} from './ace-table/ace-table-default-header/ace-table-default-header.component';
import {AceTableDefaultCellComponent} from './ace-table/ace-table-default-cell/ace-table-default-cell.component';
import {ExternalReferencesComponent} from './external-references/external-references.component';
import {ShowUserEntityLogoComponent} from './show-user-entity-logo/show-user-entity-logo.component';
import {AceSelectSharedComponent} from './ace-select-shared/ace-select-shared.component';
import {IconComponent} from './icon/icon.component';
import {DateTimeRangePickerComponent} from '@shared/components/date-time-range-picker/date-time-range-picker.component';
import {AngularSvgIconModule} from 'angular-svg-icon';
import {PageSiteAndDatePickerComponent} from '@shared/components/page-site-and-date-picker/page-site-and-date-picker.component';
import {SustainabilityRatingAttributeSelectComponent} from './sustainability-rating-attribute-select/sustainability-rating-attribute-select.component';
import {ImpactsSelectComponent} from './impacts-select/impacts-select.component';
import {SustainabilityRatingTypeSelectComponent} from './sustainability-rating-type-select/sustainability-rating-type-select.component';
import {AttachmentsComponent} from './attachments/attachments/attachments.component';
import {AttachmentStatusComponent} from './attachments/attachment-status/attachment-status.component';
import {FileNamesModalComponent} from './attachments/file-names-modal/file-names-modal.component';
import {EstimateMeterDataButtonComponent} from "@shared/components/estimate-meter-data-button/estimate-meter-data-button.component";
import {SustainabilityRatingMeasuresSelectComponent} from '@shared/components/sustainability-rating-measures-select/sustainability-rating-measures-select.component';
import {UploadStateComponent} from './attachments/upload-state/upload-state.component';
import {SustainabilityRatingSelectComponent} from './sustainability-rating-select/sustainability-rating-select.component';
import {ScoreBarComponent} from './score-bar/score-bar.component';
import {AlertTicketStatusComponent} from "@shared/components/alert-ticket-status/alert-ticket-status.component";
import {TimeLapsedComponent} from "@shared/components/abbreviated-time-lapsed/time-lapsed.component";
import {TicketStatusComponent} from "@shared/components/ticket-status/ticket-status.component";
import {AlertFaultStatusComponent} from "@shared/components/alert-fault-status/alert-fault-status.component";
import {AlertsListModalComponent} from "@shared/components/alerts-list-modal/alerts-list-modal.component";
import {PrioritySelectComponent} from '@shared/components/priority-select/priority-select.component';
import {BenefitSelectComponent} from './benefit-select/benefit-select.component';
import {ButtonComponent} from "@shared/components/button/button.component";
import {TicketsTableComponent} from "@shared/components/ticket-table/tickets-table.component";
import {DurationInputComponent} from "@shared/components/duration-input/duration-input.component";
import {DurationInputModalComponent} from "@shared/components/duration-input-modal/duration-input-modal.component";
import {TextAppendComponent} from './text-append/text-append.component';
import {AlertStatusSelectComponent} from '@shared/components/alert-status-select/alert-status-select.component';
import {ExportModalComponent} from './export-modal/export-modal.component';
import {RuleStateSelectComponent} from './rule-state-select/rule-state-select.component';
import {DurationSelectComponent} from './duration-select/duration-select.component';
import {TicketStatusSelectComponent} from './ticket-status-select/ticket-status-select.component';
import {TemplateCategorySelectComponent} from './template-category-select/template-category-select.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedPipesModule,
    NgbModule,
    SharedDirectivesModule,
    NgxDatatableModule,
    ImageCropperComponent,
    NgSelectModule,
    FontAwesomeModule,
    UiSwitchModule,
    TreeModule,
    RouterModule,
    ResizableModule,
    ngfModule,
    AngularSvgIconModule
  ],
  declarations: [
    DateTimeRangeSelectComponent,
    DateTimeRangePickerComponent,
    DemandSelectComponent,
    EquipmentSelectComponent,
    SiteSelectComponent,
    EquipmentGroupComponent,
    ErrorComponent,
    ConfirmationComponent,
    CheckboxListComponent,
    StartEndTimeComponent,
    MetadataSelectComponent,
    MetadataTypesSelectComponent,
    MetadataUnitSelectComponent,
    ErrorsComponent,
    AceCascadingSelectComponent,
    AceSelectComponent,
    AceImageCropperComponent,
    FavouritesSelectComponent,
    ClientsSelectComponent,
    TasksSelectComponent,
    AceTableComponent,
    CopyEquipmentGroupComponent,
    LevelSelectComponent,
    ZoneSelectComponent,
    ContractorSelectComponent,
    SelectFunctionModalComponent,
    ToasterComponent,
    NetworkProviderPlanSelectComponent,
    AddEditNetworkProviderPlanChargeComponent,
    NetworkProviderTypeSelectComponent,
    NetworkProviderSelectComponent,
    TimezoneSelectComponent,
    BenefitSelectComponent,
    AceChipsComponent,
    LevelZoneSelectComponent,
    LevelsSelectComponent,
    ZonenamesSelectComponent,
    TimePickerDayComponent,
    TimePickerComponent,
    LevelZoneTreeComponent,
    CountrySelectComponent,
    DateTimeSelectComponent,
    EllipsisComponent,
    HeaderComponent,
    SingleLetterIconComponent,
    EllipsesNCharsComponent,
    AceTablePagerComponent,
    CanvasChartComponent,
    ResizableContainerComponent,
    AceFileUploadComponent,
    AceLoadingComponent,
    EscalatedTicketCreateButtonComponent,
    AceCurrencyComponent,
    TemplateSelectComponent,
    RecalculateMeterdataButtonComponent,
    AcePaginationComponent,
    AceProgressBarComponent,
    SiteSelectWithSingleAndMultiComponent,
    PageSiteAndDateRangeSelectComponent,
    PageSiteAndDatePickerComponent,
    AceTableDefaultHeaderComponent,
    AceTableDefaultCellComponent,
    ShowUserEntityLogoComponent,
    AceSelectSharedComponent,
    IconComponent,
    SustainabilityRatingAttributeSelectComponent,
    ImpactsSelectComponent,
    SustainabilityRatingTypeSelectComponent,
    AttachmentsComponent,
    AttachmentStatusComponent,
    FileNamesModalComponent,
    EstimateMeterDataButtonComponent,
    SustainabilityRatingMeasuresSelectComponent,
    UploadStateComponent,
    SustainabilityRatingSelectComponent,
    ScoreBarComponent,
    AlertTicketStatusComponent,
    TimeLapsedComponent,
    TicketStatusComponent,
    AlertFaultStatusComponent,
    AlertsListModalComponent,
    PrioritySelectComponent,
    ButtonComponent,
    TicketsTableComponent,
    DurationInputComponent,
    DurationInputModalComponent,
    TextAppendComponent,
    AlertStatusSelectComponent,
    ExportModalComponent,
    RuleStateSelectComponent,
    DurationSelectComponent,
    TicketStatusSelectComponent,
    TemplateCategorySelectComponent,
    ExternalReferencesComponent
  ],
  exports: [
    DateTimeRangeSelectComponent,
    DateTimeRangePickerComponent,
    DemandSelectComponent,
    EquipmentSelectComponent,
    SiteSelectComponent,
    EquipmentGroupComponent,
    ErrorComponent,
    ConfirmationComponent,
    CheckboxListComponent,
    StartEndTimeComponent,
    MetadataSelectComponent,
    MetadataTypesSelectComponent,
    MetadataUnitSelectComponent,
    ErrorsComponent,
    AceSelectComponent,
    AceCascadingSelectComponent,
    AceImageCropperComponent,
    FavouritesSelectComponent,
    ClientsSelectComponent,
    TasksSelectComponent,
    AceTableComponent,
    CopyEquipmentGroupComponent,
    LevelSelectComponent,
    ZoneSelectComponent,
    ContractorSelectComponent,
    ToasterComponent,
    NetworkProviderPlanSelectComponent,
    AddEditNetworkProviderPlanChargeComponent,
    NetworkProviderTypeSelectComponent,
    NetworkProviderSelectComponent,
    TimezoneSelectComponent,
    AceChipsComponent,
    LevelZoneSelectComponent,
    LevelsSelectComponent,
    ZonenamesSelectComponent,
    TimePickerDayComponent,
    TimePickerComponent,
    LevelZoneTreeComponent,
    CountrySelectComponent,
    DateTimeSelectComponent,
    EllipsisComponent,
    HeaderComponent,
    SingleLetterIconComponent,
    EllipsesNCharsComponent,
    CanvasChartComponent,
    ResizableContainerComponent,
    AceFileUploadComponent,
    AceLoadingComponent,
    EscalatedTicketCreateButtonComponent,
    AceCurrencyComponent,
    TemplateSelectComponent,
    RecalculateMeterdataButtonComponent,
    AcePaginationComponent,
    SiteSelectWithSingleAndMultiComponent,
    PageSiteAndDateRangeSelectComponent,
    PageSiteAndDatePickerComponent,
    AceTableDefaultHeaderComponent,
    AceTableDefaultCellComponent,
    ShowUserEntityLogoComponent,
    AceSelectSharedComponent,
    IconComponent,
    SustainabilityRatingAttributeSelectComponent,
    SustainabilityRatingMeasuresSelectComponent,
    ImpactsSelectComponent,
    SustainabilityRatingTypeSelectComponent,
    AttachmentsComponent,
    AttachmentStatusComponent,
    FileNamesModalComponent,
    EstimateMeterDataButtonComponent,
    UploadStateComponent,
    SustainabilityRatingSelectComponent,
    ScoreBarComponent,
    TimeLapsedComponent,
    TicketStatusComponent,
    AlertFaultStatusComponent,
    AlertsListModalComponent,
    AlertTicketStatusComponent,
    PrioritySelectComponent,
    BenefitSelectComponent,
    ButtonComponent,
    TicketsTableComponent,
    DurationInputComponent,
    DurationInputModalComponent,
    TextAppendComponent,
    AlertStatusSelectComponent,
    ExportModalComponent,
    RuleStateSelectComponent,
    DurationSelectComponent,
    TicketStatusSelectComponent,
    TemplateCategorySelectComponent,
    ExternalReferencesComponent
  ]
})
export class SharedComponentsModule {}
